import { CheckboxDimensions } from 'src/components/BeaconV2Components/ExperimentalLayout/Topics/TopicBuilder/components/CheckboxItem';

export enum SidebarFilter {
  Keyword = 'k',
  KeywordPhrase = 'kp',
  KeywordExact = 'ke',
  ExcludedKeyword = 'xk',
  ExcludedKeywordExact = 'xke',
  SearchTerm = 'st',
  SearchTermFuzzy = 'stf',
  ExcludedSearchTerm = 'xst',
  Brand = 'b',
  Category = 'c',
  SubCategory = 'sc',
  ExcludedBrand = 'xb',
  ExcludedCategory = 'xc',
  ExcludedSubCategory = 'xsc'
}

/**
 * Filters for legacy topics/keywords builder
 */
export const BeaconProSidebarFilters = {
  Keyword: { filterKey: 'keyword', shortenedKey: 'k' },
  KeywordPhrase: { filterKey: 'keywordPhrase', shortenedKey: 'kp' },
  KeywordExact: { filterKey: 'keywordExact', shortenedKey: 'ke' },
  ExcludedKeyword: { filterKey: 'excludedKeyword', shortenedKey: 'xk' },
  ExcludedKeywordExact: { filterKey: 'excludedKeywordExact', shortenedKey: 'xke' },
  SearchTerm: { filterKey: 'searchTerm', shortenedKey: 'st' },
  SearchTermFuzzy: { filterKey: 'searchTermFuzzy', shortenedKey: 'stf' },
  ExcludedSearchTermFuzzy: { filterKey: 'excludedSearchTermFuzzy', shortenedKey: 'xstf' },
  ExcludedSearchTerm: { filterKey: 'excludedSearchTerm', shortenedKey: 'xst' },
  Brand: { filterKey: 'brandId', shortenedKey: 'b' },
  Category: { filterKey: 'categoryId', shortenedKey: 'c' },
  SubCategory: { filterKey: 'subCategoryId', shortenedKey: 'sc' },
  ExcludedBrand: {
    filterKey: 'excludedBrandId',
    shortenedKey: 'xb'
  },
  ExcludedCategory: {
    filterKey: 'excludedCategoryId',
    shortenedKey: 'xc'
  },
  ExcludedSubCategory: {
    filterKey: 'excludedSubCategoryId',
    shortenedKey: 'xsc'
  }
};

/**
 * Filters for the V2 topics feature
 */
export enum TopicFilter {
  IncludedKeywordPhrases = 'includedKeywordPhrases',
  ExcludedKeywordPhrases = 'excludedKeywordPhrases',
  IncludedKeywords = 'includedKeywords',
  ExcludedKeywords = 'excludedKeywords',
  IncludedBrandIds = 'includedBrandIds',
  ExcludedBrandIds = 'excludedBrandIds',
  IncludedCategoryIds = 'includedCategoryIds',
  ExcludedCategoryIds = 'excludedCategoryIds',
  IncludedSubCategoryIds = 'includedSubCategoryIds',
  ExcludedSubCategoryIds = 'excludedSubCategoryIds'
}

export const ICON_STYLES = {
  width: CheckboxDimensions.DEFAULT_WIDTH,
  height: CheckboxDimensions.DEFAULT_HEIGHT
};
